import { rotateAround } from '../Arrays';

// Polyfill for el.matches(selector)
export const matches = (el: Element | null, selector: string): boolean => {
  if (!el) {
    return false;
  }
  if (el.matches) {
    return el.matches(selector);
  }
  //@ts-ignore migrated from UIComponents
  if (el.msMatchesSelector) {
    //@ts-ignore migrated from UIComponents
    return el.msMatchesSelector(selector);
  }
  if (el.parentElement) {
    const matchingSiblings =
      el.parentElement.querySelectorAll<HTMLElement>(selector);
    for (let i = 0; i < matchingSiblings.length; i++) {
      if (matchingSiblings[i] === el) {
        return true;
      }
    }
  }
  return false;
};

export const FOCUSABLE = `
  a[href]:not([tabindex="-1"]),
  button:enabled:not([tabindex="-1"]),
  input:enabled:not([tabindex="-1"]),
  textarea:enabled:not([tabindex="-1"]),
  select:enabled:not([tabindex="-1"]),
  [tabindex]:not(:disabled):not([tabindex="-1"]),
  [contenteditable]:not(:disabled):not([tabindex="-1"])
`;

// Polyfill for el.closest(selector)
export const closest = (
  el?: HTMLElement | null,
  selector?: string
): HTMLElement | null => {
  if (!el || !selector) {
    return null;
  }
  if (el.closest) {
    return el.closest(selector);
  }
  let currentEl: HTMLElement | null = el;
  do {
    if (matches(currentEl, selector)) {
      return currentEl;
    }
    currentEl = currentEl.parentElement;
  } while (currentEl);
  return null;
};

export const moveFocusToNext = (
  selector: string,
  container: HTMLElement,
  reverse = false
): HTMLElement | null => {
  const allMatches = Array.from(
    container.querySelectorAll<HTMLElement>(selector)
  );
  if (allMatches.length === 0) return null;

  // Get an ordered list of matching elements don't already contain the focus
  const currentMenuItem = closest(
    document.activeElement as HTMLElement | null,
    selector
  );
  let candidateMatches = rotateAround(allMatches, currentMenuItem);
  candidateMatches = candidateMatches.filter(
    (menuItem) => !menuItem.contains(document.activeElement)
  );

  // If reverse is set, flip the order so we move backward in the DOM
  if (reverse) candidateMatches.reverse();

  // Move the focus to the first focusable element found within a candidate element
  for (let i = 0; i < candidateMatches.length; i++) {
    const focusTarget: HTMLElement | null =
      candidateMatches[i].querySelector<HTMLElement>(FOCUSABLE);
    if (focusTarget) {
      focusTarget.focus();
      return focusTarget;
    }
  }
  return null;
};
